export default "__VITE_ASSET__D0nvyN_J__"